module.exports = __webpack_public_path__ + "img/location-2-active.36cde793.png";